import React, { useContext, useState, useEffect } from 'react';
import {
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Typography,
	Button,
	TablePagination,
} from '@mui/material';
import MainCard from '../berry/ui-component/cards/MainCard.jsx';
import UserContext from '../context/user.jsx';
import api_ama_media from '../api/ama_media.js';

export default function AmaMediaStats() {
	const { session } = useContext(UserContext);
	const [items, set_items] = useState([]);
	const [total, set_total] = useState(0);
	const [page, set_page] = useState(0);
	const [limit, set_limit] = useState(20);
	const [sort, set_sort] = useState('desc');
	const [loading, set_loading] = useState(false);

	useEffect(() => {
		if (!session) return;
		set_loading(true);
		api_ama_media
			.stats({ session, page, limit, sort })
			.then((res) => {
				set_items(res.items || []);
				set_total(res.total || 0);
			})
			.catch(console.error)
			.finally(() => set_loading(false));
	}, [session, page, limit, sort]);

	return (
		<>
			<Button
				variant="outlined"
				size="small"
				onClick={() => set_sort(sort === 'desc' ? 'asc' : 'desc')}
				sx={{ mb: 2 }}
			>
				Sort: {sort === 'desc' ? 'Newest first' : 'Oldest first'}
			</Button>
			<MainCard content={false}>
				<TableContainer>
					<Table size="small">
						<TableHead>
							<TableRow>
								<TableCell>Time</TableCell>
								<TableCell>Query</TableCell>
								<TableCell align="right">Returned</TableCell>
								<TableCell align="right">Total</TableCell>
								<TableCell align="right">New</TableCell>
								<TableCell align="right">Filtered</TableCell>
							</TableRow>
						</TableHead>
						<TableBody>
							{loading ? (
								<TableRow>
									<TableCell colSpan={6}>
										<Typography color="textSecondary">Loading...</Typography>
									</TableCell>
								</TableRow>
							) : items.length === 0 ? (
								<TableRow>
									<TableCell colSpan={6}>
										<Typography color="textSecondary">No stats yet</Typography>
									</TableCell>
								</TableRow>
							) : (
								items.map((row) => (
									<TableRow key={row._id || row.timestamp} hover>
										<TableCell>
											{row.timestamp
												? new Date(row.timestamp).toLocaleString()
												: '-'}
										</TableCell>
										<TableCell>
											<Typography variant="body2">
												{row.query
													? JSON.stringify(row.query).slice(0, 80) +
													  (JSON.stringify(row.query).length > 80 ? '...' : '')
													: '-'}
											</Typography>
										</TableCell>
										<TableCell align="right">{row.returned ?? '-'}</TableCell>
										<TableCell align="right">{row.total ?? '-'}</TableCell>
										<TableCell align="right">{row.new ?? '-'}</TableCell>
										<TableCell align="right">{row.filtered ?? '-'}</TableCell>
									</TableRow>
								))
							)}
						</TableBody>
					</Table>
				</TableContainer>
				<TablePagination
					component="div"
					count={total}
					page={page}
					onPageChange={(_, p) => set_page(p)}
					rowsPerPage={limit}
					onRowsPerPageChange={(e) => {
						set_limit(parseInt(e.target.value, 10));
						set_page(0);
					}}
					rowsPerPageOptions={[10, 20, 50]}
				/>
			</MainCard>
		</>
	);
}
